import HowItWorksFindMock from "@/components/marketing/HowItWorksFindMock";
import HowItWorksFrictionMock from "@/components/marketing/HowItWorksFrictionMock";
import HowItWorksUseMock from "@/components/marketing/HowItWorksUseMock";
import SectionHeader from "@/components/marketing/SectionHeader";
import StepCard from "@/components/marketing/StepCard";

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="bg-white py-16">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          title="How it works"
          description="We find what to test, use it like a customer, and flag friction — not cosmetic nits."
        />

        <div className="mt-16 grid grid-cols-1 gap-8 lg:grid-cols-3">
          <StepCard
            number="1"
            title="We find what to test"
            description="Paste a product URL. We pick important public pages on our own. No page list, scripts, or personas."
            color="primary"
          >
            <HowItWorksFindMock />
          </StepCard>
          <StepCard
            number="2"
            title="We use it like a customer"
            description="Click, type, scroll. Same path a person would take."
            color="cyan"
          >
            <HowItWorksUseMock />
          </StepCard>
          <StepCard
            number="3"
            title="We flag friction, not cosmetics"
            description="Confusing next steps, extra work, dead ends. Not visual polish. Each finding shows what happened and why it slows someone down."
            color="primary"
          >
            <HowItWorksFrictionMock />
          </StepCard>
        </div>

        <p className="mx-auto mt-10 max-w-3xl text-center text-base text-gray-600">
          Public sample from your URL. To cover journeys after they log in, add a test account.
        </p>
      </div>
    </section>
  );
}
